import { useSearchParams } from "react-router-dom";
import Verdandi from "../modules/yggdrasil/Verdandi";
import Urd from "../modules/yggdrasil/Urd";
import Skuld from "../modules/yggdrasil/Skuld";

function Yggdrasil() {
  const [sp] = useSearchParams();
  const page = (sp.get("page") || "verdandi").toLowerCase();

  switch (page) {
    case "urd":
      return <Urd />;
    case "skuld":
      return <Skuld />;
    case "verdandi":
    default:
      return <Verdandi />;
  }
}

export default Yggdrasil;
